import React, { useState } from "react";
import { FaDownload, FaPaperclip } from "react-icons/fa";
import Header from "../../components/Header";

const JobOpeningApplicationPage = ({ jobTitle }) => {
  const [formData, setFormData] = useState({
    surname: "",
    otherNames: "",
    email: "",
    phone: "",
    idNumber: "",
    nationality: "",
    age: "",
    resume: null,
    academicDocuments: null,
    idDocument: null,
    applicationForm: null,
    qualifications: null,
  });

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //TODO: Add Submit form logic
    console.log("Form submitted:", formData);
  };

  return (
    <div>
      <Header />
      <div className="bg-gray-100 pb-10 sticky top-[7.5rem] z-40 h-[calc(100vh-7.5rem)] overflow-y-auto">
        <main className="container shadow-md bg-white max-w-screen-xl md:px-20 px-8 w-full mx-auto min-h-[100%]">
          <h1 className="text-2xl md:text-3xl font-semibold pt-10  text-green-700 mb-6">
            Apply for {jobTitle || "Senior Procurement Officer"} position
          </h1>
          <p className="text-gray-700 font-medium  mb-2">
            To apply for this position, please download the EAC Application Form
            from the download link below and fill in your details in the
            Applicant Information section. Complete the downloaded EAC
            Application form and upload it together with the required documents
            in the Document Uploads section.
          </p>
          <p className="text-gray-700 font-medium mt-2  mb-6">
            Click on the Submit Application button when done to complete your
            application.
          </p>

          <div className="flex  mb-10">
            <a
              href="/path/to/application-form.pdf"
              download
              className="bg-gray-200 text-green-700 px-20 py-2 rounded-lg flex items-center gap-2 hover:shadow-xl hover:bg-gray-300 font-semibold"
            >
              <FaDownload /> Download EAC Application Form
            </a>
          </div>

          {/* Application Form Section */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="bg-white p-8 border border-green-700 rounded-lg font-semibold shadow-lg space-y-4">
              {/* Personal Information */}
              <h2 className="text-xl font-semibold text-gray-800">
                Applicant Information
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <input
                  type="text"
                  name="surname"
                  placeholder="Surname"
                  value={formData.surname}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  name="otherNames"
                  placeholder="Other Names"
                  value={formData.otherNames}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                />
                <input
                  type="text"
                  name="idNumber"
                  placeholder="ID/Passport Number"
                  value={formData.idNumber}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                />
                <select
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                >
                  <option value="">Select Nationality</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Congo">Congo</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="South Sudan">South Sudan</option>
                  <option value="Uganda">Uganda</option>
                  <option value="Tanzania">Tanzania</option>
                </select>
                {/* <input
                  type="number"
                  name="age"
                  placeholder="Age"
                  value={formData.age}
                  onChange={handleInputChange}
                  required
                  className="p-4 border border-gray-300 rounded-lg"
                /> */}
              </div>
            </div>

            {/* Upload Documents Section */}
            <div className="bg-white p-8 rounded-lg shadow-lg space-y-4 border border-green-700">
              <h2 className="text-xl font-semibold text-gray-800">
                Document Uploads
              </h2>
              <p className="text-gray-600">
                Upload each document in the appropriate section below.
              </p>
              <div className="space-y-4 font-medium">
                {[
                  {
                    name: "applicationForm",
                    label: "Filled EAC Application Form",
                    required: true,
                  },
                  {
                    name: "academicDocuments",
                    label: "Academic Documents",
                    required: true,
                  },
                  { name: "resume", label: "Resume/CV", required: true },

                  {
                    name: "idDocument",
                    label: "ID/Passport Document",
                    required: true,
                  },

                  {
                    name: "qualifications",
                    label:
                      "Additional Professional Qualification Certificates/Documents",
                    required: false,
                  },
                ].map((upload, idx) => (
                  <div key={idx} className="flex items-center space-x-4">
                    <label className="w-full text-gray-600">
                      {upload.label}
                      {upload.required && (
                        <span className="text-red-600 ml-1">*</span>
                      )}
                    </label>
                    <input
                      type="file"
                      name={upload.name}
                      accept=".pdf,.doc,.docx"
                      onChange={handleFileChange}
                      required={upload.required}
                      className="p-3 border border-gray-300 font-medium text-gray-500 rounded-md w-full"
                    />
                    <FaPaperclip size={25} className="text-gray-400" />
                  </div>
                ))}
              </div>
              <p className="text-sm text-red-500 font-bold">
                ** Allowed file types: PDF only MAX: 3MB **
              </p>
            </div>

            {/* Submit Button */}
            <div className="text-center mt-8">
              <button
                type="submit"
                className="bg-green-700 text-white px-20 py-3 mb-10 rounded-lg hover:bg-green-600 font-semibold"
              >
                Submit Application
              </button>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
};

export default JobOpeningApplicationPage;
